export default {
    data() {
        return {
            dialog: {
                status: '',
                text: 'Starting...'
            },
            progressPercentage: 0,
        };
    },
    methods: {
        async processStreamData(reader, step = 33) {
            this.progressPercentage = 0;
            let errorEncountered = false;

            // eslint-disable-next-line no-constant-condition
            while (true) {
                const { value, done } = await reader.read();
                if (done) break;

                const lines = value
                    .toString()
                    .split('\n')
                    .map(line => line.trim())
                    .filter(line => line);

                for (const line of lines) {
                    if (line.startsWith('event:')) {
                        const eventValue = line.replace('event:', '').trim();
                        this.dialog.status = eventValue;
                        if (eventValue.toLowerCase().includes('error')) {
                            errorEncountered = true;
                        }
                    } else if (line.startsWith('data:')) {
                        this.dialog.text = line.replace('data:', '').trim();
                    }
                }

                this.progressPercentage += step;

                if (errorEncountered) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                    if (reader.cancel) await reader.cancel();
                    break;
                }
            }

            if (this.$refs.progressDialog) {
                this.$refs.progressDialog.closePopups();
            }
        },

        handleStreamResult(showPopup = true) {
            if (this.dialog.status.toLowerCase().includes('error')) {
                this.errorMessage = this.dialog.text;
                this.$emit('show-error', this.errorMessage);
                if (this.$refs.alert) {
                    this.$refs.alert.showAlert();
                }
            } else {
                this.dialog.text = 'Starting...';
                this.dialog.status = '';
                this.progressPercentage = 0;
                if (this.$refs.successPopup && showPopup) {
                    this.$refs.successPopup.openPopup();
                }
            }
        },
    }
};